import { render, staticRenderFns } from "./range-editor.vue?vue&type=template&id=b40500ea&scoped=true"
import script from "./range-editor.vue?vue&type=script&lang=js"
export * from "./range-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b40500ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b40500ea')) {
      api.createRecord('b40500ea', component.options)
    } else {
      api.reload('b40500ea', component.options)
    }
    module.hot.accept("./range-editor.vue?vue&type=template&id=b40500ea&scoped=true", function () {
      api.rerender('b40500ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/field-slider/range-editor.vue"
export default component.exports